"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _IndexModule = _interopRequireDefault(require("../../Index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoginUser = function LoginUser(_ref) {
  var activeResetPassword = _ref.activeResetPassword,
      loading = _ref.loading,
      errorMessage = _ref.errorMessage,
      onFinish = _ref.onFinish,
      onFinishFailed = _ref.onFinishFailed,
      setUserName = _ref.setUserName,
      setPassword = _ref.setPassword,
      setActiveResetPassword = _ref.setActiveResetPassword;

  var handleActiveResetPassord = function handleActiveResetPassord() {
    return setActiveResetPassword(!activeResetPassword);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, errorMessage && /*#__PURE__*/_react["default"].createElement("div", {
    className: "loginAlerts"
  }, /*#__PURE__*/_react["default"].createElement(_antd.Alert, {
    message: errorMessage,
    type: "error",
    showIcon: true
  })), /*#__PURE__*/_react["default"].createElement(_antd.Form, {
    name: "loginUser",
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    className: _IndexModule["default"].loginForm
  }, /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, {
    name: "username",
    rules: [{
      required: true,
      message: "Por favor introduce tu usuario"
    }]
  }, /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    prefix: /*#__PURE__*/_react["default"].createElement(_icons.UserOutlined, {
      className: "site-form-item-icon"
    }),
    className: _IndexModule["default"].customeInput,
    onChange: function onChange(e) {
      setUserName(e.target.value);
    },
    placeholder: "Usuario"
  })), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, {
    name: "password",
    rules: [{
      required: true,
      message: "Porfavor introduce tu contraseña"
    }]
  }, /*#__PURE__*/_react["default"].createElement(_antd.Input.Password, {
    prefix: /*#__PURE__*/_react["default"].createElement(_icons.LockOutlined, {
      className: "site-form-item-icon"
    }),
    className: _IndexModule["default"].customeInput,
    onChange: function onChange(e) {
      return setPassword(e.target.value);
    },
    placeholder: "Contrase\xF1a"
  })), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, {
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/_react["default"].createElement(_antd.Button, {
    type: "link",
    className: _IndexModule["default"].resetButton,
    onClick: handleActiveResetPassord
  }, "Olvid\xE9 mi contrase\xF1a")), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement(_antd.Button, {
    type: "ghost",
    htmlType: "submit",
    block: true,
    className: _IndexModule["default"].loginButton,
    loading: loading
  }, "Ingresar"))));
};

var _default = LoginUser;
exports["default"] = _default;